import type { KeycloackApi } from './keycloack-api.types'
import axios from 'axios'
import { ACCESS_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '~/constants'
import env from '~/env'
import storage from '~/foundation/storage/localstorage'
import { BASE_URL as KEYCLOACK_BASE_URL } from './keycloack-api.contants'

// Shared by every caller (the reactive 401 interceptor and the proactive
// silent-refresh check) so they join a single refresh call instead of racing
// each other. Keycloak rotates the refresh token on use, so racing refreshes
// would make every request but the first fail and wipe out the tokens the
// winning request just saved.
let refreshPromise: Promise<KeycloackApi.KeycloackTokenResponse> | null = null

async function performTokenRefresh(refreshToken: string) {
  const res = await axios.post<KeycloackApi.KeycloackTokenResponse>(`${KEYCLOACK_BASE_URL}/token`, new URLSearchParams([
    ['client_id', String(env.VITE_KEYCLOAK_CLIENT_ID)],
    ['grant_type', 'refresh_token'],
    ['refresh_token', refreshToken],
    ['redirect_uri', `${window.location.origin}/${window.location.pathname}`],
  ]))

  storage.set(ACCESS_TOKEN_STORAGE_KEY, res.data.access_token)
  storage.set(REFRESH_TOKEN_STORAGE_KEY, res.data.refresh_token)

  return res.data
}

/**
 * Renews the access/refresh tokens, joining an in-flight renewal if one is
 * already running instead of starting a competing one.
 *
 * @param refreshToken - The refresh token.
 * @returns The new tokens.
 */
export function refreshTokens(refreshToken: string) {
  refreshPromise ??= performTokenRefresh(refreshToken).finally(() => {
    refreshPromise = null
  })

  return refreshPromise
}
